import { render, staticRenderFns } from "./rename-custom-luts-folder.vue?vue&type=template&id=21c8080d&"
import script from "./rename-custom-luts-folder.vue?vue&type=script&lang=js&"
export * from "./rename-custom-luts-folder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports